const aosArgument = {
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
  initClassName: "aos-init", // class applied after initialization
  animatedClassName: "aos-animate", // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 0, // offset (in px) from the original trigger point
  delay: 50, // values from 0 to 3000, with step 50ms
  duration: 500, // values from 0 to 3000, with step 50ms
  easing: "ease", // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
};

AOS.init(aosArgument);

window.addEventListener("load", AOS.refresh);
window.addEventListener("DOMContentLoaded", () => {
  $(function () {
    // Global menu
    $('.fn-menu-btn').on('click', function() {
      $(this).stop(true, false).toggleClass('is-active');
      $(this).next('.fn-menu-container').stop(true, false).fadeToggle();
      return false;
    });
    const closeMenuFunc = () => {
      $('.fn-menu-btn').removeClass('is-active');
      $('.fn-menu-container').fadeOut('fast');
    }
    $(document).on('click', function(e) {
      if ($('.fn-menu-btn').hasClass('is-active')) {
        console.log($(e.target));
        if ($(e.target).hasClass('fn-menu-container')) {
          closeMenuFunc();
        }
        if (!$(e.target).is('a') && !$(e.target).is('button')) {
          return false;
        }
      }
    });
    
    // Accordion
    $('.fn-accordion-btn').on('click', function() {
      $(this).stop(true, false).toggleClass('is-active');
      $(this).next('.fn-accordion-content').stop(true, false).slideToggle();
      return false;
    });

    // Smooth scroll
    $('.fn-scroll-link').on('click', function(){

      if ($('.fn-menu-btn').hasClass('is-active')) {
        closeMenuFunc();
      }

      let speed = 500;
      let href= $(this).attr("href");
      let target = $(href == "#" || href == "" ? 'html' : href);
      let position = target.offset().top;
      $("html, body").animate({scrollTop:position}, speed, "swing");
      return false;
    });

  });
});
